import { Component, OnInit ,ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { I18nService } from '../../../services/i18n.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';

// 定義化學品成分介面
interface ChemicalComponent {
  chineseName: string;
  englishName: string;
  casNo: string;
  percentage: string;
}

// 修改 RegulationItem 介面，加入對應成分的索引陣列
interface RegulationItem {
  regulation?: string;
  subcategory?: string;
  casNo?: string;
  chemicalName?: string;
  englishName?: string;
  percentage?: string;
  isMatch?: boolean;
  matchedComponentIndices?: number[]; // 保存匹配到的成分索引
  matchedText?: string;       // 儲存匹配到的文字
  matchedField?:string[];
}

@Component({
  selector: 'app-chemical-regulation',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './chemical-regulation.component.html',
  styleUrl: './chemical-regulation.component.scss',
})
export class ChemicalRegulationComponent implements OnInit {
  // 用户輸入的化學品成分列表

    @Input() inputcomponents: ChemicalComponent[] = [];

components: ChemicalComponent[] = [
    { chineseName: '', englishName: '', casNo: '', percentage: '' },
  ];

  // 儲存按鈕事件，將法規列表回傳給母頁面
  @Output() saveRegulations = new EventEmitter<any[]>();

  // 匹配的法規列表
  matchedRegulations: RegulationItem[] = [];

  // 使用者實際選取的法規（可手動勾選/取消）
  selectedRegulations: RegulationItem[] = [];

  // 所有法規數據，載入一次後重複使用
  allRegulations: RegulationItem[] = [];

  // 法規名稱與id對應表
  regulationNameToIdMap: { [name: string]: string } = {};

  // 分組後的法規數據
  groupedRegulations: {
    [category: string]: { [subcategory: string]: RegulationItem[] };
  } = {};

  // 界面狀態
  searchPerformed = false;
  loading = false;

  // 用於追蹤每個分類是否啟用
  categoryEnabledMap: { [key: string]: boolean } = {};

  // 摘要文字
  summaryText: string = '';

// 添加一個屬性來跟踪所有 details 元素的開啟狀態
allDetailsOpen = true;

enabledCategories: string[] = []; // 用於存儲啟用的分類

  constructor(private http: HttpClient, private sanitizer: DomSanitizer,private cdr: ChangeDetectorRef, private i18nService: I18nService) {}

  ngOnInit(): void {
    // 載入 chemical_mapping.json，建立名稱到id的對應表
    this.http.get<any[]>('assets/data/chemical_mapping.json').subscribe({
      next: (mapping) => {
        this.regulationNameToIdMap = {};
        mapping.forEach(item => {
          this.regulationNameToIdMap[item.name] = item.id;
        });
      },
      error: (error) => {
        console.error('載入 chemical_mapping.json 失敗', error);
      }
    });

    // 在初始化時載入法規數據
    this.loading = true;
    this.http
      .get<RegulationItem[]>('assets/data/chemical_regulation.json')
      .subscribe({
        next: (data) => {
          this.allRegulations = data;
          this.loading = false;

          // 顯示 distinct regulation
          const distinctRegulations = Array.from(new Set(this.allRegulations.map(r => r.regulation).filter(Boolean)));
          console.log('distinct regulations:', distinctRegulations);

          // 如果有輸入的化學成分，則初始化成分列表，並直接按下判斷按鈕
          if(this.inputcomponents && this.inputcomponents.length > 0) {
            this.components = this.inputcomponents;
            this.checkRegulations();
          }
        },
        error: (error) => {
          console.error('載入法規數據失敗', error);
          this.loading = false;
        },
      });
  }

  // 添加新的化學成分行
  addComponent(): void {
    this.components.push({
      chineseName: '',
      englishName: '',
      casNo: '',
      percentage: '',
    });
  }

  // 移除化學成分行
  removeComponent(index: number): void {
    if (this.components.length > 1) {
      this.components.splice(index, 1);
    }
  }

  // 檢查化學品是否符合管制規定
  checkRegulations(): void {
    this.loading = true;
    this.searchPerformed = true;
    this.matchedRegulations = [];
    this.groupedRegulations = {};
    this.selectedRegulations = []; // 每次檢查時重設

    console.log(this.allRegulations);

    // 遍歷每個用户輸入的成分
    this.components.forEach((component, componentIndex) => {
      // 只處理有輸入值的成分
      if (component.chineseName || component.englishName || component.casNo) {
        // 從已載入的法規數據中搜索匹配項
        const matches = this.allRegulations.filter((reg) => {
          let isMatch = false;
          let matchedText = '';
          let matchedField :string[] = [];

          // 檢查中文名稱
          if (component.chineseName && reg.chemicalName) {
            if (reg.chemicalName.includes(component.chineseName)) {
              isMatch = true;
              matchedText = component.chineseName;
              matchedField.push('chemicalName');
            } else if (reg.englishName && reg.englishName.includes(component.chineseName)) {
              isMatch = true;
              matchedText = component.chineseName;
              matchedField.push('englishName');
            }
          }

          // 檢查英文名稱
          if (component.englishName && !isMatch) {
            if (reg.englishName && reg.englishName.includes(component.englishName)) {
              isMatch = true;
              matchedText = component.englishName;
              matchedField.push('englishName');
            } else if (reg.chemicalName && reg.chemicalName.includes(component.englishName)) {
              isMatch = true;
              matchedText = component.englishName;
              matchedField.push('chemicalName');
            }
          }

          // 检查CAS号
          if (component.casNo && reg.casNo && !isMatch) {
            if (reg.casNo.toString().includes(component.casNo)) {
              isMatch = true;
              matchedText = component.casNo;
              matchedField.push('casNo');
            }
          }

          reg.isMatch = isMatch; // 記錄匹配狀態

           // 保存匹配信息
          if (isMatch) {
            reg.matchedText = matchedText;
            reg.matchedField = matchedField;
          }

          // 檢查濃度
          if (isMatch && ! this.checkConcentrationMatch(component, reg)) {
            isMatch = false;
          }

          if (isMatch) {
            // 如果匹配成功，記錄是哪一個成分匹配到的
            if (!reg.matchedComponentIndices) {
              reg.matchedComponentIndices = [];
            }
            reg.matchedComponentIndices.push(componentIndex);
          }

          return isMatch;
        });

        // 將匹配的法規添加到結果中
        if (matches.length > 0) {
          this.matchedRegulations = [...this.matchedRegulations, ...matches];
          this.selectedRegulations = [...this.matchedRegulations]; // 預設全選
        }
      }
    });

    console.log('matchedRegulations', this.matchedRegulations);

    // 合併有相同 casNo 的項目，並保留所有匹配的成分索引
    // this.matchedRegulations = this.mergeDuplicateRegulations(
    //   this.matchedRegulations
    // );

    // 對結果進行分組
    this.groupRegulations();

    // 對結果進行分組後，初始化分類啟用狀態（默認全部啟用）
    this.initCategoryEnabledMap();

    // 生成摘要
    this.updateSummary();

    this.loading = false;


    // 手動觸發變化檢測
  setTimeout(() => {
    this.cdr.detectChanges();
  }, 0);

  }



  // // 合併相同 casNo 的匹配項，保留所有匹配的成分索引
  // private mergeDuplicateRegulations(items: RegulationItem[]): RegulationItem[] {
  //   const uniqueMap = new Map<string, RegulationItem>();

  //   items.forEach((item) => {
  //     const key = item.casNo || item.chemicalName || '';

  //     if (uniqueMap.has(key)) {
  //       // 如果已存在，合併匹配到的成分索引
  //       const existing = uniqueMap.get(key)!;

  //       if (item.matchedComponentIndices) {
  //         if (!existing.matchedComponentIndices) {
  //           existing.matchedComponentIndices = [];
  //         }

  //         // 合併並去重
  //         existing.matchedComponentIndices = [
  //           ...new Set([
  //             ...existing.matchedComponentIndices,
  //             ...item.matchedComponentIndices,
  //           ]),
  //         ];
  //       }
  //     } else {
  //       // 如果不存在，添加新項
  //       uniqueMap.set(key, { ...item });
  //     }
  //   });

  //   return Array.from(uniqueMap.values());
  // }

  // 將匹配的法規按類別和子類別分組
  private groupRegulations(): void {
    this.groupedRegulations = {};

    this.matchedRegulations.forEach((item) => {
      const category = item.regulation || '其他類別';
      const subcategory = item.subcategory || '不分類';

      if (!this.groupedRegulations[category]) {
        this.groupedRegulations[category] = {};
      }

      if (!this.groupedRegulations[category][subcategory]) {
        this.groupedRegulations[category][subcategory] = [];
      }

      this.groupedRegulations[category][subcategory].push(item);
    });

    // 對每個子分類中的項目進行排序
    Object.keys(this.groupedRegulations).forEach(category => {
      Object.keys(this.groupedRegulations[category]).forEach(subcategory => {
        // 按 CAS No 排序
        this.groupedRegulations[category][subcategory].sort((a, b) => {
          // 處理空值情況
          const casA = a.casNo || '';
          const casB = b.casNo || '';

          // 提取純數字部分進行比較（去除符號等）
          const cleanCasA = casA.replace(/[^\d.-]/g, '');
          const cleanCasB = casB.replace(/[^\d.-]/g, '');

          return cleanCasA.localeCompare(cleanCasB);
        });
      });
    });

    // 添加調試輸出
    console.log('分組並排序後的法規數據:', this.groupedRegulations);
  }

  // 初始化分類啟用狀態
  private initCategoryEnabledMap(): void {
    Object.keys(this.groupedRegulations).forEach(category => {
      this.categoryEnabledMap[category] = true;  // 預設全部啟用
    });
  }

  // 根據啟用的分類生成摘要
  updateSummary(): void {
    if (!this.matchedRegulations || this.matchedRegulations.length === 0) {
      this.summaryText = this.i18nService.translate('chemical.regulation.no_match');
      return;
    }

     this.enabledCategories = Object.keys(this.categoryEnabledMap)
      .filter(category => this.categoryEnabledMap[category]);

    if (this.enabledCategories.length === 0) {
      this.summaryText = this.i18nService.translate('chemical.regulation.no_category_selected');
      return;
    }

    let summary = this.i18nService.translate('chemical.regulation.summary_intro') + '<br><ul>';

    this.enabledCategories.forEach(category => {
      const categoryData = this.groupedRegulations[category];
      const subCategories = categoryData ? Object.keys(categoryData) : [];

      summary += `<li><strong>${category}</strong>：`;

      if (subCategories.length > 1) {
        summary += '<ul>';
        subCategories.forEach(subCategory => {
          const items = categoryData[subCategory];
          summary += `<li>${subCategory}</li>`;
        });
        summary += '</ul>';
      } else if (subCategories.length === 1) {
        const items = categoryData[subCategories[0]];
        summary += `${subCategories[0]}`;
      }

      summary += '</li>';
    });

    summary += '</ul>';

    // 添加成分對應信息
    summary += '<br>' + this.i18nService.translate('chemical.regulation.related_components') + '<br><ul>';

    // 獲取所有被匹配的成分索引
    const affectedIndices = new Set<number>();
    this.enabledCategories.forEach(category => {
      const categoryData = this.groupedRegulations[category];
      // 添加空值检查
      if (categoryData) {
        Object.keys(categoryData).forEach(subCategory => {
          categoryData[subCategory].forEach(item => {
            if (item.matchedComponentIndices) {
              item.matchedComponentIndices.forEach(index => {
                affectedIndices.add(index);
              });
            }
          });
        });
      }
    });

    // 列出每個受影響的成分
    Array.from(affectedIndices).sort().forEach(index => {
      const component = this.components[index];
      const componentName = component.chineseName || component.englishName || component.casNo || this.i18nService.translate('chemical.regulation.unnamed');
      summary += `<li>${this.i18nService.translate('chemical.regulation.component_number', { number: index + 1 })}：${componentName}</li>`;
    });

    summary += '</ul>';

    this.summaryText = summary;
  }

  // 重置搜索
  resetSearch(): void {
    this.searchPerformed = false;
    this.matchedRegulations = [];
    this.groupedRegulations = {};
    this.components = [
      { chineseName: '', englishName: '', casNo: '', percentage: '' },
    ];
    this.categoryEnabledMap = {};
    this.summaryText = '';
  }

  getUniqueComponentIndices(indices?: number[]): number[] {
    if (!indices || indices.length === 0) {
      return [];
    }

    // 使用 Set 來去除重複值
    return Array.from(new Set(indices));
  }

  checkConcentrationMatch(ingredient: ChemicalComponent, regInfo: RegulationItem): boolean {
    // 已經判斷為不匹配，直接返回
    if (!regInfo.isMatch) {
      return false;
    }

    // 如果沒有限制百分比要求，直接返回匹配結果
    if (!regInfo.percentage || regInfo.percentage === "") {
      return true;
    }

    // 處理成分濃度
    let ingredientConcentration: number;

    if (!ingredient.percentage || ingredient.percentage === "") {
      ingredientConcentration = 100; // 如果沒有指定濃度，默認為100%
    } else {
      // 從字串中提取所有數字（包括小數點）
      const numberMatches = ingredient.percentage.match(/\d+(\.\d+)?/g);

      if (!numberMatches || numberMatches.length === 0) {
        // 如果無法提取數字，默認為100%
        ingredientConcentration = 100;
      } else {
        // 將所有匹配的數字轉換為數值並取最大值
        ingredientConcentration = Math.max(...numberMatches.map(n => parseFloat(n)));
      }
    }

    // 從法規百分比中提取數字
    const regNumberMatches = regInfo.percentage?.match(/\d+(\.\d+)?/g);
    const regConcentration = regNumberMatches && regNumberMatches.length > 0
      ? Math.max(...regNumberMatches.map(n => parseFloat(n)))
      : 0;

    // 比較濃度
    return ingredientConcentration >= regConcentration;
  }

// 高亮顯示匹配文字
highlightText(text: string | undefined, matchedText: string | undefined): SafeHtml {
  if (!text || !matchedText) {
    return text || '-';
  }

  // 使用正則表達式替換匹配的文字，添加高亮樣式
  const regex = new RegExp(this.escapeRegExp(matchedText), 'g');
  const highlightedText = text.replace(regex, match => `<span style="background-color:#f5820d4a;padding: 2px;
  border-radius: 2px;
  font-weight: bold;">${match}</span>`);

  // 使用 DomSanitizer 標記為安全的 HTML
  return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
}

// 轉義正則表達式特殊字符
private escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


// 切換所有 details 元素的展開/收合狀態
toggleAllDetails(): void {
  this.allDetailsOpen = !this.allDetailsOpen;

  // 使用 setTimeout 確保在 DOM 更新後可以找到所有 details 元素
  setTimeout(() => {
    const detailsElements = document.querySelectorAll('details.regulation-subcategory');
    detailsElements.forEach(element => {
      if (this.allDetailsOpen) {
        element.setAttribute('open', '');
      } else {
        element.removeAttribute('open');
      }
    });
  }, 0);
}

  // 儲存按鈕觸發
  onSave(): void {

    const mappedIds = this.enabledCategories
      .map(name => (typeof name === 'string' ? this.regulationNameToIdMap[name] : undefined))
      .filter((id): id is string => !!id);
    this.saveRegulations.emit(mappedIds);
  }
// 檢查某 regulation 是否已被選取
isRegulationSelected(item: RegulationItem): boolean {
  return this.selectedRegulations.some(
    sel => sel.regulation === item.regulation && sel.casNo === item.casNo
  );
}

// 切換 regulation 勾選狀態
toggleRegulationSelection(item: RegulationItem, checked: boolean): void {
  if (checked) {
    // 避免重複加入
    if (!this.isRegulationSelected(item)) {
      this.selectedRegulations.push(item);
    }
  } else {
    // 移除未勾選的
    this.selectedRegulations = this.selectedRegulations.filter(
      sel => !(sel.regulation === item.regulation && sel.casNo === item.casNo)
    );
  }
}
}

